import { useApiClient } from '@/api/client.js'
import { type CheckInClient } from '../types.ts'

import { decamelizeKeys } from '@/functions/utils'

export const ADD_CLIENT_TO_LIST = '/core/v2/business_api/me/businesses/{businessId}/turntracker/list/append'

export const addClientToList = (options: {
  businessId: number;
  payload: CheckInClient;
}) => {
  const apiClient = useApiClient()

  return apiClient.post({
    url: ADD_CLIENT_TO_LIST,
    urlParams: {
      businessId: options.businessId,
    },
    data: decamelizeKeys(options.payload),
  })
}
